export const pageview = (state) => {
    return state.pageView;
}

export const favorite = (state) => {
    return state.favorite;
}

export const bg_music = (state) => {
    return state.bg_music;
}

export const navAndTabbarShow = (state) => {
	return state.navAndTabbarShow;
}

export const tabbarIndex = (state) => {
	return state.tabbarIndex;
}

export const allProductDate =(state) =>{
    return state.product_data;
}


// WEBPACK FOOTER //
// ./src/store/getters.js